import React from 'react';
import { Loader2, AlertCircle } from 'lucide-react';
import Header from '../Header';
import Footer from '../Footer';
import { useSiteContent } from '../../hooks/useSiteContent';

const SiteHtmlPage = ({ slug, wrapperClass = 'min-h-screen bg-gradient-to-b from-purple-50/40 via-white to-pink-50/30', containerClass = '' }) => {
  const { page, loading, error } = useSiteContent(slug);

  return (
    <div className={wrapperClass}>
      <Header />
      <div className={containerClass || 'px-4'}>
        {loading && (
          <div className="flex justify-center py-20">
            <Loader2 className="h-10 w-10 animate-spin text-purple-600" />
          </div>
        )}

        {!loading && error && (
          <div className="max-w-4xl mx-auto rounded-2xl border border-red-200 bg-red-50 p-6 text-red-700 flex items-start gap-3">
            <AlertCircle className="h-5 w-5 shrink-0 mt-0.5" />
            <div>
              <p className="font-semibold">Content load nahi ho paya</p>
              <p className="text-sm mt-1">{error}</p>
            </div>
          </div>
        )}

        {!loading && page && page.content_html && (
          <div
            className="site-content-html"
            dangerouslySetInnerHTML={{ __html: page.content_html }}
          />
        )}

        {!loading && page && !page.content_html && (
          <p className="text-center text-gray-500 py-12">Content abhi available nahi hai.</p>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default SiteHtmlPage;
